/**
 * Share-link addresses. Kept free of heavy imports: the router reads SHARE_PATH
 * on every page. The token goes after "#", which browsers never send to a server.
 */
export const SHARE_PATH = '/share';

export function shareUrl(token: string, origin = location.origin): string {
  return `${origin}${SHARE_PATH}#${token}`;
}

/** The token in this page's address, or null if it is not a share link. */
export function tokenFromHash(hash: string): string | null {
  const t = hash.replace(/^#/, '').trim();
  return /^[A-Za-z0-9_-]{43}$/.test(t) ? t : null;
}
